<template>
  <app-page title="Jobs" subtitle="View and (optionally) manage jobs" icon="briefcase">
    <template v-slot:infobox>
      <sme-info-box title="About Jobs" id="about-jobs" save-state>
        <p>Stream can hold jobs/rate tables where appropriate, to allow for more complex wage calculations.</p>
        <p>
          Jobs should be discussed with your project team to ensure all scenarios are catered for and as standard, the
          below data model will be followed.
        </p>
        <div class="mt-3">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Job Code</th>
                <th>Rate</th>
                <th>Multiplier</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>The code that associates the rate of pay with the shift worked.</td>
                <td>The rate of pay to two decimal places.</td>
                <td>The multiplier associated to the shift type (i.e. 2x normal pay).</td>
              </tr>
            </tbody>
          </table>
        </div>
      </sme-info-box>
      <sme-info-box title="How can I add jobs?" id="adding-jobs" save-state>
        <p>
          The easiest way to manage jobs is to use an
          <router-link :to="{ name: 'sme-integrations' }">integration</router-link>
          with popular HR software providers.
        </p>
        <p v-if="canAddJobs">
          Alternatively, you can manually provide us job data -- imported
          <router-link :to="{ name: 'sftp-bulk-upload', query: { entity: 'jobs' } }"> in bulk </router-link> -- at your
          preferred schedule via the portal.
        </p>
      </sme-info-box>
      <sme-info-box title="How can I edit jobs?" id="editing-jobs" save-state>
        <p v-if="canAddJobs">
          If you have uploaded job data through our portal, please edit or remove the job on your job file and
          re-upload.
        </p>
        <p>You can also manually edit individual jobs on the portal by clicking on the job and updating the details.</p>
        <p v-if="!canAddJobs">
          If you are integrated with an HR system, you will need to update the jobs on their platform. Any updates that
          you make will be reflected on this page upon the next sync.
        </p>
      </sme-info-box>
    </template>
    <template v-slot:header v-if="State.state.claims.a">
      <b-button
        v-if="canAddJobs"
        :to="{ name: 'sftp-bulk-upload', query: { entity: 'jobs' } }"
        variant="outline-primary"
      >
        <font-awesome-icon :icon="['fal', 'upload']" class="mr-2" /> Bulk Import
      </b-button>
    </template>

    <template v-slot:custom-content>
      <b-col>
        <sme-alert v-if="!canViewJobs" level="danger">
          You do not have permission to view jobs. Please contact your administrator.
        </sme-alert>
        <b-card v-else>
          <jobs-list class="mt-3" />
        </b-card>
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import AppPage from '@/components/AppPage.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import SmeInfoBox from '@/components/atoms/SmeInfoBox.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import JobsList from '@/pages/jobs/components/JobsList.vue';
import State from '@/state/State';

const { canAddJobs, canViewJobs } = useFeatureFlags();
</script>
